import React, { useEffect } from 'react';
import { DialogActions, Box } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { ButtonV2 } from 'components/common/ui';
import { FieldV2 } from 'components/common/form-controls';
import { useFormErrorsNotification } from '@hooks';

import { modalStyles as styles } from './userBillingInfo.style';
import {
  addValidationSchema,
  editValidationSchema,
} from './userBillingInfosValidationSchema';

const contractOptions = [
  {
    text: 'Ιδιώτης',
    value: 'Ιδιώτης',
  },
  {
    text: 'Εταιρεία',
    value: 'Εταιρεία',
  },
];

const UserBillingInfoForm = ({ onSubmit, onCancel, defaultValues, isNew }) => {
  const resolver = yupResolver(
    isNew ? addValidationSchema : editValidationSchema
  );
  const methods = useForm({
    resolver,
    mode: 'onChange',
    defaultValues,
  });
  const { handleSubmit, reset } = methods;

  useEffect(() => {
    if (defaultValues) {
      reset(defaultValues);
    }
  }, [defaultValues, methods]); // eslint-disable-line react-hooks/exhaustive-deps

  useFormErrorsNotification(methods.formState.errors);

  const contract = methods.watch('contract');
  const isCompany = contract === 'Εταιρεία';

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={styles.row}>
          {isNew && (
            <FieldV2
              control={methods.control}
              disabled={methods.formState.isSubmitting}
              isRequired
              name="contract"
              label="Contract"
              type="dropdown"
              options={contractOptions}
            />
          )}
        </Box>
        <Box sx={styles.row}>
          <FieldV2
            control={methods.control}
            disabled={methods.formState.isSubmitting}
            isRequired
            name="firstName"
            label="First Name"
          />
          <FieldV2
            control={methods.control}
            disabled={methods.formState.isSubmitting}
            isRequired
            name="lastName"
            label="Last Name"
          />
        </Box>
        <Box sx={styles.row}>
          <FieldV2
            control={methods.control}
            disabled={methods.formState.isSubmitting}
            isRequired
            name="vat"
            label="Tax code"
          />
          {isCompany && (
            <FieldV2
              control={methods.control}
              disabled={methods.formState.isSubmitting}
              isRequired={isCompany}
              name="companyName"
              label="Business Name:"
            />
          )}
        </Box>
        <Box sx={styles.row}>
          <FieldV2
            control={methods.control}
            disabled={methods.formState.isSubmitting}
            isRequired
            name="doi"
            label="D.O.Y"
          />
          <FieldV2
            control={methods.control}
            disabled={methods.formState.isSubmitting}
            isRequired
            name="activity"
            label="Activity"
          />
        </Box>
        <Box sx={styles.row}>
          <FieldV2
            control={methods.control}
            disabled={methods.formState.isSubmitting}
            isRequired
            name="phoneNumber"
            label="Phone Number"
          />

          <FieldV2
            control={methods.control}
            disabled={methods.formState.isSubmitting}
            isRequired
            name="email"
            label="E-mail"
          />
        </Box>
        <Box sx={styles.row}>
          <FieldV2
            control={methods.control}
            disabled={methods.formState.isSubmitting}
            isRequired
            name="address"
            label="Street Address"
          />

          <FieldV2
            control={methods.control}
            disabled={methods.formState.isSubmitting}
            isRequired
            name="postalCode"
            label="Postal Code"
          />
        </Box>
        <DialogActions>
          <ButtonV2 variant="outlined" onClick={onCancel}>
            Cancel
          </ButtonV2>
          <ButtonV2 type="submit" disabled={methods.formState.isSubmitting}>
            OK
          </ButtonV2>
        </DialogActions>
      </form>
    </FormProvider>
  );
};

export default UserBillingInfoForm;
